import { isEqual } from 'lodash';

export const getMaximumAttendeesErrorMessage = (
  maximumAttendees: number,
  limit: number,
): string | null => {
  if (maximumAttendees === 0) return null;
  if (Number.isNaN(maximumAttendees)) return 'Max attendees must be a number';
  if (maximumAttendees < 1) return 'Max attendees must be at least 1';
  if (maximumAttendees > limit)
    return `Max attendees must be less than or equal to ${limit}`;
  return null;
};

export const hasFormChanges = <T extends Record<string, any>>(
  currentState: T,
  initialState: T,
  excludeFields: (keyof T)[] = [],
): boolean => {
  const comparableCurrent = { ...currentState };
  const comparableInitial = { ...initialState };

  excludeFields.forEach((field) => {
    delete comparableCurrent[field];
    delete comparableInitial[field];
  });

  return !isEqual(comparableCurrent, comparableInitial);
};
